import * as transitions from 'view/styles/transitions';

export const MODAL_EXPAND_TRANSITION_MS = transitions.speedMs.medium;
